export default __webpack_public_path__ + "static/media/logoAbbott.c461faf1.png";